import { AriaDescriber, FocusMonitor } from '@angular/cdk/a11y';
import { Directionality } from '@angular/cdk/bidi';
import { Overlay, ScrollDispatcher } from '@angular/cdk/overlay';
import { Platform } from '@angular/cdk/platform';
import { AfterViewChecked, Directive, ElementRef, Inject, NgZone, Optional, ViewContainerRef } from '@angular/core';
import {
  MatTooltip,
  MatTooltipDefaultOptions,
  MAT_TOOLTIP_DEFAULT_OPTIONS,
  MAT_TOOLTIP_SCROLL_STRATEGY
} from '@angular/material/tooltip';

@Directive({
  selector: '[vfsIsEllipsisActive]'
})
export class IsEllipsisActiveDirective extends MatTooltip implements AfterViewChecked {
  constructor(
    private elementRef: ElementRef,
    matOverlay: Overlay,
    matElementRef: ElementRef,
    matScrollDispatcher: ScrollDispatcher,
    matViewContainerRef: ViewContainerRef,
    matNgZone: NgZone,
    matPlatform: Platform,
    matAriaDescriber: AriaDescriber,
    matFocusMonitor: FocusMonitor,
    @Inject(MAT_TOOLTIP_SCROLL_STRATEGY) matScrollStrategy: any,
    @Optional() matDir: Directionality,
    @Optional()
    @Inject(MAT_TOOLTIP_DEFAULT_OPTIONS)
    matDefaultOptions: MatTooltipDefaultOptions
  ) {
    super(
      matOverlay,
      matElementRef,
      matScrollDispatcher,
      matViewContainerRef,
      matNgZone,
      matPlatform,
      matAriaDescriber,
      matFocusMonitor,
      matScrollStrategy,
      matDir,
      matDefaultOptions
    );
  }

  ngAfterViewChecked(): void {
    this.checkEllipsis();
  }

  checkEllipsis() {
    const element = this.elementRef.nativeElement;
    if (element.offsetWidth < element.scrollWidth || element.offsetHeight < element.scrollHeight) {
      element.classList.add('with-ellipsis');
      this.message = element.innerText;
    } else {
      this.message = '';
    }
  }
}
